import { restClient } from '../config/restClient'

const endpoint = (hiringTeamId, positionId) => `/api/company/v2/hiring_teams/${hiringTeamId}/job_openings/${positionId}/attachment`

export const postPositionAttachment = async (hiringTeamId, positionId, data) => {
  const response = await restClient(endpoint(hiringTeamId, positionId), {
    method: 'POST',
    data,
  })

  return response.data
}

export const deletePositionAttachment = async (hiringTeamId, positionId) => {
  const response = await restClient(endpoint(hiringTeamId, positionId), {
    method: 'DELETE',
  })

  return response.data
}
